import { Badge } from '@zoom/components';
import React from 'react';
import { useTranslation } from 'react-i18next';

type AdherenceHistoryBadgeProps = {
  children: number;
  displayValueAsWord?: boolean;
  kind: 'primary' | 'danger' | 'info';
};

export const AdherenceHistoryBadge: React.FC<AdherenceHistoryBadgeProps> = ({
  children,
  displayValueAsWord = false,
  kind,
}) => {
  const { t } = useTranslation();

  if (children === 0) {
    return (
      <span className="adherence-history__badge-no-issue">
        {displayValueAsWord ? t('layout.confirm.no') : children}
      </span>
    );
  }

  return (
    <Badge className={`adherence-history__badge adherence-history__badge--${kind}`} kind={kind}>
      {displayValueAsWord ? t('layout.confirm.yes') : children}
    </Badge>
  );
};
